import logger from '../utils/rbata.logger';
import employee from '../employee/rbata.employee';

const plpService = {
    facetCounterMobile: undefined,
    productCodesList:   [],
    fetchFragment(url) {
        logger.log(`Fetch products ... = ${url}`);
        return $.ajax({
            url:    url,
            method: 'GET',
            cache:  false
        });
    },
    replaceFilterBar(data) {
        $('#js-filter-bar--desktop').html($(data).find('#js-filter-bar--desktop').html());
    },
    replaceFacets(data) {
        $('#js-facets').html($(data).find('#js-facets').html());
    },
    exchangeProducts(data) {
        const newProducts = $(data).filter('#plp__fragment__products').html();
        $('#plp__grid').html(newProducts);
    },
    addAppliedFacetsDesktop() {
        // render applied values from all other facets
        $('#js-filter-bar--desktop').find('.dropdown--facet').each((index, element) => {
            const $element         = $(element);
            const appliedFacetsNum = $element.find('.dropdown-item--active').length;

            // if there is one active item in the list render the clear button
            if (appliedFacetsNum !== 0) {
                $element.find('.js-facet__reset--hack').removeClass('dropdown-toggle__reset--active');
                $element.find('.js-dropdown-toggle__counter').text(appliedFacetsNum);
            }
        });
    },
    setFacetCounterMobile(amount) {
        if (!this.facetCounterMobile) {
            this.facetCounterMobile = $('#js-open-facet-overlay').find('.js-dropdown-toggle__counter');
        }
        this.facetCounterMobile.text(amount);
    },
    addAppliedFacetsMobile() {
        let totalFacets = 0;
        // render applied values from all other facets
        $('#facet__overlay--facets').find('.dropdown--mfacet').each((index, element) => {
            const $element         = $(element);
            const appliedFacetsNum = $element.find('.dropdown-item--active').length;

            totalFacets = totalFacets + appliedFacetsNum;
            // if there is one active item in the list render the clear button
            if (appliedFacetsNum !== 0) {
                $element.find('.js-facet__reset').removeClass('dropdown-toggle__reset--active');
                $element.find('.js-dropdown-toggle__counter').text(appliedFacetsNum);
            }
        });
        totalFacets !== 0 ? this.setFacetCounterMobile(totalFacets) : this.setFacetCounterMobile('');
    },
};

export default plpService;
